import { InnerView, SiteDeclaration } from "~/components";
import { FBProfile } from "~/.server/api";

interface AboutUsInnerViewProps {
  profile?: FBProfile;
}

export default function AboutUsInnerView({ profile }: AboutUsInnerViewProps) {
  return (
    <InnerView id="about-us" title="About Us" showFooter={false} user={profile}>
      <div className="p-4 flex flex-col gap-2 text-text">
        <h1 className="text-xl font-bold text-primary">About Us</h1>
        <p>hello@flirtybum.com</p>

        <h1>Welcome to flirtybum.com</h1>
        <p>
          flirtybum.com is an online entertainment and social networking website
          where like-minded people chat, flirt, and fulfill their wildest
          fantasies. Our platform is accessible via desktop, tablet, Smartphone
          and is 100% discreet.
        </p>

        <SiteDeclaration />
      </div>
    </InnerView>
  );
}
